var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatascrapBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3003",
    "data-name": "Group 3003",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2203",
    "data-name": "Rectangle 2203",
    width: 5,
    height: 1,
    transform: "translate(4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    width: 13,
    height: 1,
    transform: "translate(0 2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2209",
    "data-name": "Rectangle 2209",
    width: 9,
    height: 1,
    transform: "translate(2 13)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2204",
    "data-name": "Rectangle 2204",
    width: 1,
    height: 2,
    transform: "translate(4)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    width: 1,
    height: 11,
    transform: "translate(10 3)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2208",
    "data-name": "Rectangle 2208",
    width: 1,
    height: 11,
    transform: "translate(2 3)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2210",
    "data-name": "Rectangle 2210",
    width: 1,
    height: 6,
    transform: "translate(5 5)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2211",
    "data-name": "Rectangle 2211",
    width: 1,
    height: 6,
    transform: "translate(7 5)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    width: 1,
    height: 2,
    transform: "translate(8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatascrapBin);
export default __webpack_public_path__ + "static/media/datascrap_bin.3e1ccd7f5af31a2e11af801c9354379c.svg";
export { ForwardRef as ReactComponent };